import type { ErpModule } from '@/api/platform.api';
import { LAUNCHER_ERP_MODULES } from '@/config/moduleDefaults';
import { moduleApprovalsPath } from '@/config/moduleWorkPaths';

export function parseApprovalOwnerModule(ownerModule?: string | null): ErpModule | null {
  if (!ownerModule) return null;
  const normalized = ownerModule.trim().toUpperCase().replace(/-/g, '_') as ErpModule;
  return LAUNCHER_ERP_MODULES.includes(normalized) ? normalized : null;
}

export function approvalInboxDeepLink(ownerModule: string | null | undefined, instanceId: number): string {
  const owner = parseApprovalOwnerModule(ownerModule);
  const path = owner ? moduleApprovalsPath(owner) : '/work/approvals';
  return `${path}?instance=${instanceId}`;
}
